<template>
    <transition name="modal">
        <div class="modal__mask modalpep" v-if="showModalCreate > 0">
            <div class="modal__wrapper">
                <div class="modal__container reset">
                    <div class="content__modal">


                        <div class="inner__modal_docs">
                            <img style="width: 40px; height: 47px;" src="@/assets/question.png" />
                            <h2>Termos de uso</h2>

                            <div style="max-height: 320px; min-height: 250px; max-width: 400px; padding-right: 25px; padding-left: 25px; overflow: hidden scroll;">
                                <span id="conteudoImpressao" v-html="conteudoTermosFormatado">
                                </span>
                            </div>

                            
                            <div class="buttonsAcoes" :style="bloquearAceite ? 'justify-content: center; padding-bottom: 30px;' : 'padding-bottom: 30px;'">

                   <div class="row" style="margin-left: 50px">

                    <span style="color: red; margin-left: 0px;" v-if="erroConfirmar">Necessário aceitar os termos para confirmar adesão ao produto</span>


                    <div class="label__field" style="width: 100%; display: inline-flex; margin-bottom: 10px; margin-left: 15px;">

                        <input
                            type="checkbox"
                            class="accept"
                            style="margin-top: 10px;"
                            name=""
                            v-model="aceitoTermos"
                            id="accept"
                            :disabled="bloquearAceite"
                        />

                      <label class="label"   style="margin-top: 6px; margin-left: 5px;" for="accept">Li e aceito os termos de uso.</label>

                    </div>


                                <button v-if="bloquearAceite != true" class="btnBlue" style="width: 260px" @click="confirmar">Confirmar</button>
                           
                                <button class="btnDefault" style="width: 260px; margin-top: 5px;" @click="closeModal">Voltar</button>

                           
                            </div>

                            </div>


                        </div>

                        

                    </div>
                </div>
            </div>
            <div v-if="requisicaoPendente" class="loading-overlay">
                <div class="spinner"></div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from "vuex";
import api from '@/api/axios';

export default {
    computed: {
        ...mapGetters({
            showModalCreate: 'GET_MODAL_TERMOS_DOCUMENTOS',
            bloquearAceite: 'GET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE',
            listaDocumentosClientes: 'GET_LISTA_DOCUMENTOS_CLIENTE',
            listaDocumentos: 'GET_LISTA_DOCUMENTOS',
            habImpressao: 'GET_MODAL_TERMOS_DOCUMENTOS_IMPRESSAO',
            user: 'auth/user',
        }),
        conteudoTermosFormatado() {
        // Adiciona target="_blank" a todas as tags <a>
        return this.conteudoTermos.replace(/<a href/g, '<a target="_blank" href');
        }
    },
    data() {
        return { 
            aceitoTermos: false,
            erroConfirmar: false,
            conteudoTermos: '',
            requisicaoPendente: false
        }
    },
    watch: {
        showModalCreate(){
            this.aceitoTermos = this.bloquearAceite;
            if(this.showModalCreate > 0){
                if(this.listaDocumentosClientes != null && this.listaDocumentosClientes.filter(obj => obj.TemplateId == this.showModalCreate)[0] != null){
                    this.conteudoTermos = this.listaDocumentosClientes.filter(obj => obj.TemplateId == this.showModalCreate)[0]?.Texto;
                }else{
                    this.conteudoTermos = this.listaDocumentos.filter(obj => obj.TemplateId == this.showModalCreate)[0]?.Texto;
                }
            }else{
                this.conteudoTermos = '';
            }
        }
    },
    methods: {
        closeModal() {
            this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS", 0);
            this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE", false);
            this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS_IMPRESSAO", false);
            
            this.erroConfirmar = false;
        },
        async getIpAddress() {
            try {
                const response = await fetch("https://api.ipify.org?format=json");
                const data = await response.json();
                return data.ip;
            } catch (error) {
                console.error("Error fetching IP address:", error);
                return null;
            }
        },
        async confirmar(){
            if(!this.aceitoTermos){
                this.erroConfirmar = true;
            }else{
                
                     
                    var ip = await this.getIpAddress();
                    var obj = { ClienteId: this.user.ClienteId, DeclaracaoId: 0, TemplateId: this.showModalCreate, UsuarioAssinatura: this.user.NomeRazaoSocial, Status: 'Assinado', DataAssinatura: new Date(), IP: ip };
                    this.requisicaoPendente = true;

                    const retorno = await api.post('/declaracao/cliente', obj);
                            if (retorno.status == 200) {
                                    this.$swal({
                                    icon: 'success',
                                    title: 'Ler os termos',
                                    text: 'Termos aceitos com sucesso',
                                }).then((result) => {
                                    this.requisicaoPendente = false;
                                    if (result.value) {
                                        this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS", 0);
                                        this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE", false);
                                        this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS');
                                        this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_CLIENTE', this.user.ClienteId);
                                    }
                                });
                         
                            }else{
                                this.requisicaoPendente = false;
                                this.$swal({
                                        icon: 'error',
                                        title: 'Oops...',
                                        text: `Falha ao aceitar os termos`,
                                });
                            }


            }
        }
    },
};
</script>

<style lang="scss">
@include modal;

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.subTitle{
    color: #383333;;
    margin-top: -30px;
    margin-bottom: 30px; 
    font-size: large; 
    font-family: "Work Sans", sans-serif;
    font-weight: 400 !important;
}

.inner__modal_docs{

    margin-top: 40px !important;
    width: 450px !important;
    align-content: center;

    h2{
       margin-bottom: 20px !important;
    }

    span{
    color: #667085;;
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    }


    img{
        margin-left: 42%;
    }

}


.modalpep .modal__wrapper .modal__container.reset {
        width: 400px;
        height: 680px !important;
}

.titleConta{
        font-weight: 800 !important;
        text-transform: uppercase;
}

.btnLogin{
    background-color: #565656 !important;
}

.subTitleCinza{
    width: 52%;
    text-align: center;
    font-weight: 400 !important;
    color: #707070 !important;
        font-family: "Work Sans", sans-serif;
}

.content__modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    .close__modal {
        position: absolute;
        right: 34px;
        top: 30px;
        font-family: "Montserrat";

        @media (max-width: 768px) {
            top: 16px;
            right: 16px;
        }
    }

    h3 {
        margin-bottom: 46px;

        @media (max-width: 768px) {
            font-size: 24px;
            margin-bottom: 20px;
            text-align: center;
            max-width: 280px;
        }
    }
}
</style>
